module.exports = __webpack_public_path__ + "media/images/Scholar-7f930a6112325daca98ea4897d231b84.png";